/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ZoomService } from '../../../modules/shared/services/zoom.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'dash-gis-zoom-button',
    template: ` <button mat-icon-button (click)="zoomTo()">
        <mat-icon svgIcon="zoom-in" aria-label="Zoom"></mat-icon>
    </button>`,
    imports: [MatIconButton, MatIcon],
})
export class ZoomButtonComponent implements OnInit {
    @Output() zoom = new EventEmitter<void>();
    @Input() zoomLayer: string;
    @Input() zoomObjectField: string;
    @Input() zoomObjectKey: any;
    @Input() otherZoomLayers: string[] = [];

    constructor(private zoomService: ZoomService) {}

    ngOnInit(): void {}

    zoomTo() {
        this.zoom.next();

        this.zoomService.zoom(this.zoomLayer, this.zoomObjectField, this.zoomObjectKey, this.otherZoomLayers);
    }
}
